export default import.meta.ROLLUP_FILE_URL_epdbhdyBUyD3hvxx0_dcTg;